import SelectRank from './src/main';

/* istanbul ignore next */
SelectRank.install = function(Vue) {
  Vue.component(SelectRank.name, SelectRank);
};

export default SelectRank;
